export default __webpack_public_path__ + "static/media/introduce_yourself.6c38d09a.svg";